module.exports = __webpack_public_path__ + "media/images/map/red-tick-icon-4a2804a1e91eb2b964a75cf3a195e76a.svg";